package pl.zar.tikthrow.ui.media

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun ImageFromUri(uri: String, isVideo: Boolean, modifier: Modifier) {
    Box(modifier = modifier)
}
